// extracted by mini-css-extract-plugin
module.exports = {"streamChatWidget":"jgp-v_Nwo"};